// 贯石科技默认使用协议内容
const DEFAULT_AGREEMENT = `
欢迎使用贯石科技平台！请您在使用本系统前仔细阅读并同意以下协议：

1. 您的账户信息仅用于平台身份认证和业务操作，不会泄露给第三方。
2. 您不得利用本平台从事任何违法违规活动。
3. 平台有权根据业务需要对服务内容进行调整，并提前通知用户。
4. 如有疑问请联系平台管理员。

点击“我已阅读并同意”即表示您已充分理解并接受本协议全部内容。
`;

export default DEFAULT_AGREEMENT;